import { getAction, postAction } from "@/api/common";
import { Message } from "element-ui";
import i18n from "@/i18n";

const TOKEN_CACHE_KEY = "authToken";
const COORDINATOR_CACHE_KEY = "isCoordinator";

const state = {
  token: localStorage.getItem(TOKEN_CACHE_KEY) || null,
  isCoordinator: JSON.parse(localStorage.getItem(COORDINATOR_CACHE_KEY)) || false, // 是否为后台业务人员
  userInfo: {}, // 用户信息
};

const getters = {
  getBearerToken: state => "Bearer " + state.token, // http请求时携带的token
};

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token;
    localStorage.setItem(TOKEN_CACHE_KEY, token);
  },
  SET_IS_COORDINATOR(state, bool) {
    state.isCoordinator = bool;
    localStorage.setItem(COORDINATOR_CACHE_KEY, bool);
  },
  SET_USER_INFO(state, data) {
    state.userInfo = data;
  },
  RESET_USER(state) {
    state.token = null;
    state.isCoordinator = false;
    // 清除本地缓存
    localStorage.removeItem(TOKEN_CACHE_KEY);
    localStorage.removeItem(COORDINATOR_CACHE_KEY);
  },
};

const actions = {
  // 账号密码登录(普通用户)
  accountLogin({ commit }, data) {
    return new Promise((resolve, reject) => {
      postAction("/doLogin", data)
        .then(res => {
          if (res.token) {
            commit("SET_TOKEN", res.token);
            commit("SET_IS_COORDINATOR", false);
            resolve();
          } else {
            const i18nMessageError = i18n.messages[i18n.locale].common.error;
            Message.error(i18nMessageError.loginToken);
            reject();
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  // 令牌直接登录(后台业务人员)
  coordinatorLogin({ commit }, { token, id }) {
    return new Promise((resolve, reject) => {
      postAction("/doInternalUserLogin", { sysToken: token, replacementUserId: id })
        .then(res => {
          if (res.token) {
            commit("SET_TOKEN", res.token);
            commit("SET_IS_COORDINATOR", true);
            resolve();
          } else {
            const i18nMessageError = i18n.messages[i18n.locale].common.error;
            Message.error(i18nMessageError.loginToken);
            reject();
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  // 获取用户信息
  fetchUserInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getAction("/member/profile", {})
        .then(res => {
          const resData = res.data;
          commit("SET_USER_INFO", resData);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  // 退出登录
  logout({ commit }) {
    commit("RESET_USER");
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
